import * as Api from '@ViewModels';
import { IImpersonationContext } from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import ReactModal from 'react-modal';
import { CloseButton } from '../../../../../web/components/CloseButton';
import { TestimonialImageEditorModalContent } from '../../../../../web/containers/TestimonialImageEditor';
import { styleSheet } from './styles';

type Props = {
	accountId: string;
	impersonationContext: IImpersonationContext;
	onClose: () => void;
	selectedReview: Api.IGoogleBusinessReview | null;
};

export const TestimonialModal: React.FC<Props> = ({ accountId, impersonationContext, onClose, selectedReview }) => {
	return (
		<ReactModal
			isOpen={Boolean(selectedReview)}
			onRequestClose={onClose}
			className={css(styleSheet.testimonialModalContent)}
			overlayClassName={css(styleSheet.testimonialModalOverlay)}
			shouldCloseOnOverlayClick={false}
		>
			<div className={css(styleSheet.testimonialModalHeader)}>
				<h2 className={css(styleSheet.testimonialModalHeaderTitle)}>Create Testimonial Post</h2>
				<CloseButton onClick={onClose} fillColor='white' />
			</div>
			<div className={css(styleSheet.testimonialModalBody)}>
				{selectedReview && (
					<TestimonialImageEditorModalContent
						accountId={accountId}
						containerStyles={[styleSheet.containerStyles]}
						builderStyles={[styleSheet.builderStyles]}
						impersonationContext={impersonationContext}
						onPostCreated={onClose}
						testimonial={{
							type: 'google_review',
							data: { ...selectedReview, includeGeneratedReply: false },
						}}
					/>
				)}
			</div>
		</ReactModal>
	);
};
